import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 8a5 5 0 0 0 8.536 3.536l-1.061-1.061c-.195-.195-.51-.191-.735-.031a3 3 0 1 1 0-4.888c.225.16.54.164.735-.03l1.06-1.062A5 5 0 0 0 2 8Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.97 5.47a.75.75 0 0 1 .53-.22H14a.75.75 0 0 1 .53 1.28L13.06 8l1.47 1.47a.75.75 0 0 1-.53 1.28h-2.5a.75.75 0 0 1-.53-.22L9.19 8.75H7a.75.75 0 0 1 0-1.5h2.19l1.78-1.78Z"
      fill="currentColor"
    />
    <circle cx={7} cy={8} r={1.5} fill="currentColor" />
  </svg>
);

const StyledSvgTarget = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgTarget;
